module.exports = __webpack_public_path__ + "d4c2eeb3175ebc04356be61419790ac5.svg";